/* Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 * 
 *   http://www.apache.org/licenses/LICENSE-2.0
 * 
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { GetterTree, Getter } from 'vuex'
import { State } from './index'

// const cartProducts: Getter<State, any> = (state: State) => {
//   return state.cart.added.map((shape) => {
//     const product = state.products.all.find((p) => p.id === shape.id)
//     if (product) {
//       const cartProduct: CartProduct = {
//         title: product.title,
//         price: product.price,
//         quantity: shape.quantity,
//       }
//       return cartProduct
//     }
//   })
// }

const getterTree: GetterTree<State, any> = {
}

export default getterTree



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/getters.ts